// extracted by mini-css-extract-plugin
export default {"app":"styles_app--l6CL0","noselect":"styles_noselect--NE5ba"};